import { SystemState, UPDATE_SYSTEM, SystemActionTypes } from './types';

export function updateSystem(newSystem: SystemState): SystemActionTypes {
  return {
    type: UPDATE_SYSTEM,
    payload: newSystem
  };
}
